import type { PropsWithChildren, RefObject } from 'react';
import React, { useMemo } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { TrackChangesPluginOptions } from '@atlaskit/editor-plugin-track-changes/track-changes-plugin-type';

import type { AIPlugin } from '@atlassian/editor-plugin-ai/aiPluginType';

import { fg } from '@confluence/feature-gating';

import { AIStreamingSpotlight } from '../../entry-points/AIStreamingSpotlight.ts';

export type EditorAPI = PublicPluginAPI<[AIPlugin]>;
export type EditorAPIRef = RefObject<EditorAPI | null | undefined>;

export type TrackChangesPluginProps = {
	editorAPIRef: EditorAPIRef;
};

export type TrackChangesPlugin = {
	pluginOptions: TrackChangesPluginOptions;
};

export const useTrackChangesPlugin = ({
	editorAPIRef,
}: TrackChangesPluginProps): TrackChangesPlugin => {
	const pluginOptions: TrackChangesPluginOptions = useMemo(() => {
		// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
		if (!fg('cc_aifc_ai_streaming_spotlight')) {
			return {};
		}

		return {
			ButtonWrapper: ({ children }: PropsWithChildren) => (
				<AIStreamingSpotlight editorAPIRef={editorAPIRef}>{children}</AIStreamingSpotlight>
			),
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { pluginOptions };
};
